import {ISelectOption} from '../../select/select';

export const VIDEO_QUALITY: Array<ISelectOption> = [{
  label: 'Low',
  value: 'low',
}, {
  label: 'Good',
  value: 'good',
}, {
  label: 'High',
  value: 'high',
}];
